// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2F3Kn","fullScreen":"style_fullScreen__2O8CI","hidden":"style_hidden__1-86v"};